module.exports = __webpack_public_path__ + "img/game_memory.55604a51.webp";